module.exports = __webpack_public_path__ + "media/src/img/fond_old-b58ba080259093a091e1ce20f6d4d2cf.svg";